import React from 'react';
export function ForWhoSection() {
  return <section className="py-10 px-5 bg-negro" data-id="element-70">
      <h2 className="font-playfair text-[clamp(22px,3.5vw,34px)] text-center text-blanco mb-6" data-id="element-71">
        ¿Para quién es Efecto Diamante?
      </h2>
      <div className="grid grid-cols-2 gap-5 max-w-[900px] mx-auto" data-id="element-72">
        <div className="rounded-2xl p-5 bg-[linear-gradient(135deg,rgba(78,205,196,0.1),rgba(78,205,196,0.05))] border border-[rgba(78,205,196,0.3)]" data-id="element-73">
          <h3 className="text-[17px] font-bold mb-3 text-teal" data-id="element-74">
            ✓ SÍ es para vos si...
          </h3>
          <ul className="list-none" data-id="element-75">
            {['Querés diferenciarte con chocolate de autor premium', 'Buscás ingresos reales y constantes desde casa', 'Querés cobrar lo que realmente vale tu trabajo', 'Sos repostera y querés subir de nivel', 'Empezás de cero y querés hacerlo bien', 'Querés una marca aesthetic que se venda sola'].map((item, i) => <li key={i} className="text-[14px] text-[#cccccc] py-1.5 flex items-start gap-2 border-b border-[rgba(255,255,255,0.05)] last:border-b-0" data-id="element-76">
                <span className="text-teal font-bold shrink-0" data-id="element-77">✓</span>
                {item}
              </li>)}
          </ul>
        </div>
        <div className="rounded-2xl p-5 bg-[linear-gradient(135deg,rgba(255,80,80,0.1),rgba(255,80,80,0.05))] border border-[rgba(255,80,80,0.2)]" data-id="element-78">
          <h3 className="text-[17px] font-bold mb-3 text-[#ff6b6b]" data-id="element-79">
            ✗ NO es para vos si...
          </h3>
          <ul className="list-none" data-id="element-80">
            {['Buscás resultados sin esfuerzo ni práctica', 'Esperás hacerte rica de un día para el otro', 'Tenés una fábrica industrial establecida', 'No estás dispuesta a invertir tiempo en aprender'].map((item, i) => <li key={i} className="text-[14px] text-[#cccccc] py-1.5 flex items-start gap-2 border-b border-[rgba(255,255,255,0.05)] last:border-b-0" data-id="element-81">
                <span className="text-[#ff6b6b] font-bold shrink-0" data-id="element-82">✗</span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}